import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const problems = [{
  tag: '😩 Problème n° 1',
  title: '« Je m’ennuie ! » — encore et encore',
  text: 'Même avec une chambre pleine de jouets. Même juste après avoir acheté quelque chose de nouveau. Le cycle de l’ennui ne s’arrête jamais et vous êtes à court d’idées.',
  img: 'https://cdn.magicpatterns.com/uploads/ihjE7DKY1ufhoEJhsEe429/IMG_1064.webp',
  alt: 'Jeune enfant qui pleure à côté de ses jouets',
  tone: 'bg-coral-light',
  tagTone: 'bg-coral/20 text-coral'
}, {
  tag: '📱 Problème n° 2',
  title: 'Des écrans. Toute la journée. Tous les jours.',
  text: 'Vous lui donnez une tablette « juste une minute » et deux heures plus tard, il y est encore collé. Rien ne les captive comme un écran — et vous détestez ça.',
  img: 'https://cdn.magicpatterns.com/uploads/iF8QAP4AAhfEAASdSCwhT5/IMG_1063.webp',
  alt: 'Enfant frustré qui fixe une tablette',
  tone: 'bg-sky-light',
  tagTone: 'bg-sky/20 text-sky'
}, {
  tag: '😤 Problème n° 3',
  title: 'Vous avez tout essayé — rien ne marche',
  text: 'Kits créatifs, puzzles, activités en plein air… ça dure un après-midi. Vous continuez à dépenser argent et énergie, et pourtant rien ne retient leur attention plus d’une journée.',
  img: 'https://cdn.magicpatterns.com/uploads/wLtfrSPqS9mi15yuLtP3pw/IMG_1062.webp',
  alt: 'Deux enfants cachés derrière leurs téléphones',
  tone: 'bg-sunshine-light',
  tagTone: 'bg-sunshine/30 text-ink'
}, {
  tag: '😭 Problème n° 4',
  title: 'La crise quand on retire l’écran',
  text: 'Chaque fois que vous limitez le temps d’écran, c’est la bataille. Larmes, caprices, négociations. Vous vous sentez le méchant, alors que vous voulez seulement le meilleur pour eux.',
  img: 'https://cdn.magicpatterns.com/uploads/by9pMNhj1jGZXhdizermvD/IMG_1065.webp',
  alt: 'Petite fille qui pleure à côté d’un ours en peluche',
  tone: 'bg-brand-light',
  tagTone: 'bg-brand/15 text-brand'
}];
export function Problems() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-145" data-mp="kw7pi3v95zc8">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-146" data-mp="kwpv3r3t1pwt">
        <SectionHeading eyebrow="Ça vous parle ?" title="Vous connaissez ce sentiment ?" subtitle="Tous les parents le connaissent. Vous voulez que vos enfants s’éloignent des écrans et se consacrent à quelque chose de concret — mais rien ne semble retenir leur attention bien longtemps." data-id="element-147" data-mp="fw21qys3swzf" />
        <div className="mt-14 grid gap-6 sm:grid-cols-2" data-id="element-148" data-mp="16e2s47eaaev">
          {problems.map((p, i) => <motion.article key={p.tag} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className={`flex flex-col overflow-hidden rounded-3xl border border-ink/10 ${p.tone}`} data-id="element-149" data-mp="3tc9g62ubo20s" data-mpi={i}>
              <div className="aspect-[4/3] w-full overflow-hidden" data-id="element-150" data-mp="3e8ghr0x08007">
                <img src={p.img} alt={p.alt} className="h-full w-full object-cover" data-id="element-151" data-mp="3j7t0b9guekwz" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-152" data-mp="2lhy4j72kgi92">
                <span className={`mb-3 w-fit rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide ${p.tagTone}`} data-id="element-153" data-mp="2qk6zua2wvwec">
                  {p.tag}
                </span>
                <h3 className="font-display text-xl font-bold text-ink" data-id="element-154" data-mp="308oyaknpxret">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-155" data-mp="22si22e7bmfq0">
                  {p.text}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}